export default ['member', 'manager', 'administrator', 'owner']
